export default __webpack_public_path__ + "static/media/roadmap-q1.92943c83.png";